import React, { useState, useEffect } from "react";
import {
  FaEnvelope,
  FaFacebook,
  FaHeart,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa";

// const Footer = () => {
//   return (
//     <>
//       <footer className="text-center px-3 py-1"
//       style={{backgroundColor: "#F8F9FA", bottom:0, width:"100%", position: "fixed"}}>
//         <div>
//           <i className="social fa-brands px-2"><FaTwitter /></i>
//           <i className="social fa-brands px-2"><FaFacebook /></i>
//           <i className="social fa-brands px-2"><FaInstagram /></i>
//           <i className="social fa-solid px-2"><FaEnvelope /></i>
//         </div>
//         <p style={{fontSize: "0.8rem", color: "#8f8f8f", marginTop: "10px"}}>
//           © Copyright kudtarkarSahil
//         </p>
//       </footer>
//     </>
//   );
// };

const Footer = () => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(window.pageYOffset > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <footer
      className={`text-center px-3 py-1 ${isScrolling ? "" : "sticky"}`}
      style={{
        backgroundColor: "#F8F9FA",
        bottom: 0,
        width: "100%",
        position: isScrolling ? "relative" : "fixed",
      }}
    >
      <div>
        <i className="social fa-brands px-2">
          <a
            href={`https://instagram.com/kudtarkarSahil`}
            target="_blank"
            rel="noreferrer" style={{color: "black"}}
          >
            <FaInstagram />
          </a>
        </i>
        <i className="social fa-brands px-2">
          <FaTwitter />
        </i>
        <i className="social fa-brands px-2">
          <FaFacebook />
        </i>
        <i className="social fa-solid px-2">
          <a
            href={`mailto:sahilkudtarkar315@gmail.com`}
            target="_blank"
            rel="noreferrer" style={{color: "black"}}
          >
            <FaEnvelope />
          </a>
        </i>
      </div>
      <p
        style={{
          fontSize: "0.8rem",
          color: "#8f8f8f",
          marginTop: "10px",
          fontWeight: "normal",
        }}
      >
        © Copyright 2023 |{" "}
        <span className="text-dark fw-medium">kudtarkarSahil</span>{" "}
        <FaHeart className="fs-6" /> from{" "}
        <span className="text-dark fw-medium">India</span>
      </p>
    </footer>
  );
};

export default Footer;
